module.exports = __webpack_public_path__ + "static/collins-collins-fdbe0a38e2605d1aed1d96e2a924fb94.mp4";